import { render, staticRenderFns } from "./VesselPrintShipTypePieChart.vue?vue&type=template&id=12fb0970&scoped=true&"
import script from "./VesselPrintShipTypePieChart.vue?vue&type=script&lang=js&"
export * from "./VesselPrintShipTypePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb0970",
  null
  
)

export default component.exports